import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Poster/Poster.css";

const Poster = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleBookNow = () => {
    window.location.href = "tel:02033557350  ";
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    cssEase: "cubic-bezier(0.83, 0, 0.17, 1)",

    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,

    beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
  };

  const images = [
    { src: "/pp.webp", color: "#0066ff" },
    { src: "/p2.webp", color: "#0099ff" },
    { src: "/p1.webp", color: "#00ccff" },
  ];

  return (
    <div className={`poster-container ${isVisible ? "visible" : ""}`}>
      {/* Background Effects */}
      <div className="bg-elements">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
        <div className="particle-field"></div>
        <div className="light-ray"></div>
      </div>

      {/* Slider */}
      <div className="slider-wrapper">
        <Slider {...sliderSettings}>
          {images.map((img, index) => (
            <div
              key={index}
              className={`slide-item ${index === currentSlide ? "active" : ""}`}
            >
              <div className="image-container">
                <img
                  src={img.src}
                  alt="slide"
                  className="slide-image"
                  style={{ "--slide-color": img.color }}
                />
                <div className="color-overlay"></div>
                <div className="gradient-mask"></div>
              </div>
            </div>
          ))}
        </Slider>

        {/* Progress */}
        <div className="slide-progress">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${((currentSlide + 1) / images.length) * 100}%`,
              }}
            ></div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="main-content">
        <h1 className="main-headline">
          <span className="headline-line line-1">Journey</span>
          <span className="headline-line line-2">Beyond Ordinary</span>
        </h1>

        <button className="book-now-btn" onClick={handleBookNow}>
          <span className="btn-icon">✈️</span>
          <span className="btn-text">Call To Book</span>
          <span className="btn-arrow">→</span>
        </button>
      </div>
      {/* Vertical Overlay Logos */}
      <div className="overlay-logos">
        <img src="/visa.webp" alt="logo-1" />
        <img src="/mastercard.webp" alt="logo-2" />
        <img src="/american.webp" alt="logo-3" />
        <img className="oat" src="/atol.webp" alt="logo-4" />
      </div>

      {/* Orbs */}
      <div className="orb-container">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
      </div>
    </div>
  );
};

export default Poster;
